import { render, staticRenderFns } from "./List1Mini.vue?vue&type=template&id=973fad00&"
import script from "./List1Mini.vue?vue&type=script&lang=js&"
export * from "./List1Mini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports